// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".navigation-link[data-v-1d0c849a]{color:#ced4da;font-size:.875rem}.navigation-link[data-v-1d0c849a]:hover{color:#ff7a00;-webkit-text-decoration:none;text-decoration:none}.gray-theme .navigation-link[data-v-1d0c849a]{color:#707da7}.gray-theme .navigation-link[data-v-1d0c849a]:hover{color:#ff7a00;-webkit-text-decoration:none;text-decoration:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
